import {Component, OnInit} from '@angular/core';
import {PreloaderService} from "../../services/preloader/preloader.service";
import {DomSanitizer, SafeHtml, SafeResourceUrl, Title} from "@angular/platform-browser";
import {AlertController, ModalController, Platform} from "@ionic/angular";
import {MyGreenCountry} from "../../services/mygreencountry/my-greencountry";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../services/mygreencountry/auth.service";
import {Observable} from "rxjs";
import {TranslocoService} from "@jsverse/transloco";

@Component({
    selector: 'app-certificate',
    templateUrl: './certificate.page.html',
    styleUrls: ['./certificate.page.scss'],
})
export class CertificatePage implements OnInit {
    title$: Observable<string>;

    certificateExist:boolean;
    uuid: string;
    html: string;
    htmlSafe: SafeHtml
    isHybridApp = false
    certificateUrlPath = ''

    urlSafe: SafeResourceUrl = '';
    urlSafeDownload: SafeResourceUrl = '';
    windowWidth: number;
    isParentRole:boolean|undefined = undefined;

    set certificateUrl(value:string)
    {
        this.certificateUrlPath = value;
        this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(value);
        this.urlSafeDownload = this.sanitizer.bypassSecurityTrustResourceUrl(this.myGcService.getCertificateUrlDownload(value));
    }

    constructor(
        private preloaderService: PreloaderService,
        public myGcService: MyGreenCountry,
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        public alertCtrl: AlertController,
        public router: Router,
        private platform: Platform,
        private authService: AuthService,
        private translocoService: TranslocoService,
        private titleService: Title
    ) {
        this.title$ = this.translocoService.selectTranslate('route.certificateParent');
        console.log("this.title$");
        console.log(this.title$);

        this.title$.subscribe(title => {
            this.titleService.setTitle(title);
        });
    }

    ngOnInit() {
        this.uuid = this.route.snapshot.paramMap.get('uuid') as string;
        this.isHybridApp = this.platform.is('hybrid');
        this.windowWidth = window.innerWidth;

        if (this.uuid) {
            this.openCertificate(this.uuid)
        }
    }

    ionViewDidEnter() {
        this.isParentRole = this.authService.isParentRole();
    }

    async openCertificate(uuid: string) {
       await this.preloaderService.showLoading("Зачекайте, будь ласка ");

        this.myGcService
            .openCertificate(uuid)

            .subscribe({
                next: async (response) => {

                    this.certificateExist = response.successes

                    this.html = response.html;

                    this.certificateUrl = this.myGcService.getCertificateUrl(uuid);

                    if (this.html && this.certificateExist) {
                        this.htmlSafe = this.sanitizer.bypassSecurityTrustHtml(this.html)
                    } else {
                        await this.alert(
                            '',
                            'This certificate does not exist',
                            [{
                                text: 'ok',
                                handler: (data: any) => {

                                    this.router.navigate(['/home'])

                                }
                            }]);
                    }


                },

                error: (error) => {

                    this.preloaderService.hideLoading();

                    if (error.status === 401) {
                        this.router.navigate(['/home'])
                    }else{
                        this.alert(
                            '',
                            'This certificate does not exist',
                            [{
                                text: 'ok',
                                handler: (data: any) => {

                                    this.router.navigate(['/home'])

                                }
                            }]);
                    }
                },

                complete:
                    () => {
                        this.preloaderService.hideLoading();
                    }

            })
    }


    async alert(header: string, subHeader: string, buttons: any = []) {

        let alert = await this.alertCtrl.create({
            header: header,
            subHeader: subHeader,
            buttons: buttons
        });
        await alert.present();

    }

    download()
    {
        this.myGcService.openUrl(this.certificateUrlPath + '?download=1');

    }

    onResize(event: Event) {
        this.windowWidth = (event.target as Window).innerWidth;
    }

    isSmallScreen(): boolean {
        return this.windowWidth < 768;
    }
}
